import type { ReactNode } from "react";
import { useFintechUiStyles, useModuleBEM } from "@b2bportal/core-themes";
import { CoreFintechUiComponents } from "@b2bportal/core-types";
import { Icon, type IconComponentProp } from "@tenant/ui";
import clsx from "clsx";
import defaultStyles from "./FintechProductBullet.module.scss";

export interface FintechProductBulletProps {
  icon?: IconComponentProp;
  children: ReactNode;
  className?: string;
}

export const FintechProductBullet = (props: FintechProductBulletProps) => {
  const COMPONENT_KEY = CoreFintechUiComponents.FintechProductBullet;
  const styles = useFintechUiStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  return (
    <div className={clsx(block, props.className)}>
      {props.icon != null && (
        <Icon
          useCurrentColor={false}
          {...props.icon}
          className={clsx(cn("icon"), props.icon.className)}
        />
      )}
      <span className={cn("text")}>{props.children}</span>
    </div>
  );
};
